import React from "react";
import { theme } from "./theme";
export const ThemeContext = React.createContext();

const getMode = JSON.parse(localStorage.getItem("rohan-theme")) || "dark";

const ThemeContextProvider = ({ children }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [mode, setMode] = React.useState(getMode);

  const toggleTheme = () => {
    setMode((prevState) => (prevState === "dark" ? "light" : "dark"));
  };

  React.useEffect(() => {
    localStorage.setItem("rohan-theme", JSON.stringify(mode));
  }, [mode]);

  console.log("contextapi", getMode);

  const newTheme = theme[mode];

  const handleOpen = () => {
    setIsOpen(!isOpen);
  };
  const value = { isOpen, handleOpen, mode, toggleTheme, newTheme };
  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};

export default ThemeContextProvider;
